import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {}

const DownloadIcon: React.FC<Props> = () => {
  return (
    <SVGIcon width="14" height="14" viewBox="0 0 14 14">
      <path
        d="M8.25 0.125V1.375H11.7266L4.05078 9.05078L4.94922 9.94922L12.625 2.27344V5.75H13.875V0.125H8.25ZM0.125 2.625V13.875H11.375V5.75L10.125 7V12.625H1.375V3.875H7L8.25 2.625H0.125Z"
        fill="#187A90"
      />
    </SVGIcon>
  );
};

export default DownloadIcon;
